import { Component, OnInit } from '@angular/core';
import {
    //UntypedFormBuilder,
    UntypedFormGroup
    //Validators
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PubSubConstants } from '@zlib/config';
import { AuthResponse, AuthService } from '@zlib/services/auth.service';
import { PubSubService } from '@zlib/services/pubsub.services';
import { ToastService } from '@zlib/services/toast.service';
import { ResourceUtil } from '@zshared/utilities/resource';
import { mergeMap } from 'rxjs';
import { Subscription } from '../../../../lib/data-access/models/subscription.model';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [TranslateModule]
})
export class LoginComponent implements OnInit {
    validateForm!: UntypedFormGroup;
    passwordVisible = false;
    returnUrl: string = '';
    loading: boolean = true;
    loadingBtn: boolean = false;

    constructor(
        private readonly resource: ResourceUtil,
        private readonly toastService: ToastService,
        private readonly authService: AuthService,
        private readonly translateService: TranslateService,
        private readonly route: ActivatedRoute,
        private readonly pubsub: PubSubService
    ) {}

    asset(url: string) {
        return this.resource.asset(url);
    }

    ngOnInit(): void {
        this.initKeycloak();

        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    initKeycloak() {
        this.authService
            .getProfile(this.returnUrl)
            .pipe(mergeMap(() => this.authService.getSubscription()))
            .subscribe({
                next: (res: Subscription[]) => {
                    this.toastService.createSuccessNotification(
                        this.translate('login.notification.success'),
                        ''
                    );
                    if (!res?.length) {
                        this.pubsub.$pub(
                            PubSubConstants.EVENTS.REDIRECT_ROUTE,
                            '/dashboard/onboarding'
                        );
                    } else {
                        this.pubsub.$pub(
                            PubSubConstants.EVENTS.REDIRECT_ROUTE,
                            this.returnUrl
                        );
                    }
                },
                error: (e) => {
                    this.loadingBtn = false;
                    console.error(e);
                    this.toastService.createErrorNotification(
                        this.translate('login.notification.connection_fail'),
                        ''
                    );
                },
                complete: () => {
                    this.loadingBtn = false;
                    this.loading = false;
                }
            });
    }

    translate(translateText: string): string {
        return this.translateService.instant(translateText);
    }

    errorHandle(res: AuthResponse) {
        if (res.errors) {
            this.toastService.createErrorNotification(
                this.translate('auth_err.' + res.errors[0].code),
                ''
            );
        } else if (res.isLockedOut) {
            this.toastService.createErrorNotification(
                this.translate('auth_err.is_locked_out'),
                ''
            );
        } else if (res.isNotAllowed) {
            this.toastService.createErrorNotification(
                this.translate('auth_err.is_not_allowed'),
                ''
            );
        } else if (res.requiresTwoFactor) {
            this.toastService.createErrorNotification(
                this.translate('auth_err.requires_two_factor'),
                ''
            );
        } else if (res.requiresTwoFactor) {
            this.toastService.createErrorNotification(
                this.translate('auth_err.requires_two_factor'),
                ''
            );
        } else {
            this.toastService.createErrorNotification(
                this.translate('auth_err.fail'),
                ''
            );
        }
    }
}
